import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useFontAwesomeIcon } from "./platform";
import { faExternalLinkAlt } from "@fortawesome/pro-light-svg-icons";
export const InlineLink = React.memo(function InlineLink(props) {
    const FontAwesomeIcon = useFontAwesomeIcon();
    return (_jsx("a", { href: props.href, target: "_blank", rel: "noreferrer", children: _jsxs("div", { style: { display: "inline-block", color: "#0798f2", cursor: "pointer" }, children: [props.label ?? props.href, " ", _jsx("div", { style: { display: "inline-block", fontSize: "0.8em", paddingTop: "0.1em", verticalAlign: "top" }, children: _jsx(FontAwesomeIcon, { icon: faExternalLinkAlt }) })] }) }));
});
